var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3835 13.9268C8.4523 14.0267 8.54437 14.1084 8.65177 14.1648C8.75916 14.2213 8.87867 14.2508 9 14.2508C9.12133 14.2508 9.24083 14.2213 9.34823 14.1648C9.45563 14.1084 9.54769 14.0267 9.6165 13.9268L16.3665 4.17675C16.4446 4.06429 16.4904 3.93257 16.499 3.7959C16.5075 3.65924 16.4784 3.52284 16.4149 3.40155C16.3513 3.28025 16.2557 3.17869 16.1385 3.10789C16.0213 3.0371 15.8869 2.99979 15.75 3H2.25C2.11338 3.00057 1.9795 3.03836 1.86276 3.10932C1.74602 3.18029 1.65083 3.28173 1.58742 3.40275C1.52402 3.52376 1.49481 3.65977 1.50293 3.79615C1.51105 3.93253 1.55619 4.06411 1.6335 4.17675L8.3835 13.9268Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/select-icon.2e4bd051e40c245141d7df222d5179b6.svg";
export { ForwardRef as ReactComponent };